// extracted by mini-css-extract-plugin
export default {"root":"OrderTable_root__lrH+t","heading":"OrderTable_heading__u2VO8","list-container":"OrderTable_list-container__otU2t"};